import idb from '@/services/idb';
import api from '@/services/api'

const SYNC_RUNNING = 2;
const SYNC_FINISH = 1;
const SYNC_WAITING = 0;
// seul code par lequel eKo confirme l'ecriture du fichier
const HTTP_CREATED = 201;
// au dela, une photo laissee en SYNC_RUNNING ne peut plus correspondre a une
// requete en vol : le timeout d'envoi est de 120 s
const SYNC_STALE_MS = 5 * 60 * 1000;

const errorStatus = (e) => {
	return e && e.response ? e.response.status : null;
};

// 400 {"response":{"message":"Aucun fichier recu"}}
// 500 {"response":{"message":"Envoi incomplet : ..."}}
const errorMessage = (e) => {
	if (e && e.response && e.response.data && e.response.data.response) {
		return e.response.data.response.message;
	}
	return e ? e.message : 'erreur inconnue';
};
const base64ToBlob = (dataurl) => {
	const arr = dataurl.split(',');
	const mime = arr[0].match(/:(.*?);/)[1]
	const sliceSize = 1024;
	const byteChars = window.atob(arr[1]);
	const byteArrays = [];
	
	for (let offset = 0, len = byteChars.length; offset < len; offset += sliceSize) {
		let slice = byteChars.slice(offset, offset + sliceSize);
		
		const byteNumbers = new Array(slice.length);
		for (let i = 0; i < slice.length; i++) {
			byteNumbers[i] = slice.charCodeAt(i);
		}
		
		const byteArray = new Uint8Array(byteNumbers);
		
		byteArrays.push(byteArray);
	}
	
	return new Blob(byteArrays, {type: mime});
}

const getFilename = (dataUrl) => {
	const arr = dataUrl.split(',');
	const mime = arr[0].match(/:(.*?);/)[1];
	
	return Math.round(+new Date() / 1000) + '.' + mime.split('/').pop();
}

const store = {
	namespaced: true,
	state: {
		pictures: [],
		uid: null
	},
	mutations: {
		remove(state, picture) {
			state.pictures.splice(state.pictures.indexOf(picture), 1);
		},
		setpictures(state, pics) {
			state.pictures = pics;
		},
		addpicture(state, pic) {
			state.pictures.push(pic);
		},
		reset(state) {
			state.pictures = [];
			state.uid = null;
			
		},
		setuid(state, uid) {
			state.uid = uid;
		},
	},
	
	actions: {
		async delete(context, picture) {
			await idb.deletePicture(picture);
			context.commit('remove', picture);
		},
		async load(context, uid) {
			
			if (context.state.uid != uid) {
				context.commit('reset');
				
				let pictures = await idb.getPictures(uid);
				context.commit('setpictures', pictures);
				context.commit('setuid', uid);
				console.log('fin load');
			}
		},
		async loadall(context) {
			context.commit('reset');
			let pictures = await idb.getAllPictures();
			context.commit('setpictures', pictures);
			context.commit('setuid', null);
			
		},
		
		// pendant de interventions/requeueRunning : une photo laissee en
		// SYNC_RUNNING par une sync interrompue n'est plus jamais reprise,
		// getPicturesBySync ne selectionnant que SYNC_WAITING
		async requeueRunning(context) {
			let all = await idb.getAllPictures();
			for (const picture of all.filter((p) => p.sync === SYNC_RUNNING)) {
				await idb.patchPicture(picture.id, {sync: SYNC_WAITING, syncstartedat: null});
				let loaded = context.state.pictures.find((p) => p.id === picture.id);
				if (loaded) {
					loaded.sync = SYNC_WAITING;
				}
				context.dispatch('journal/log', {
					uid: picture.uid, name: picture.name, index: picture.index,
					pictureid: picture.id, level: 'warn',
					message: 'photo bloquee en cours d envoi, remise en attente au demarrage',
				}, {root: true});
			}
		},
		
		// pendant du requeue au demarrage, mais pour une app qui reste ouverte :
		// une requete tuee en vol (WebView mise en veille, reseau coupe) laisse la
		// photo en SYNC_RUNNING et invisible pour getPicturesBySync(SYNC_WAITING).
		// L'age evite de requalifier une requete encore reellement en cours.
		async requeueStale(context) {
			let all = await idb.getAllPictures();
			let now = Date.now();
			for (const picture of all.filter((p) => p.sync === SYNC_RUNNING)) {
				if (picture.syncstartedat && (now - picture.syncstartedat) < SYNC_STALE_MS) {
					continue;
				}
				await idb.patchPicture(picture.id, {sync: SYNC_WAITING, syncstartedat: null});
				let loaded = context.state.pictures.find((p) => p.id === picture.id);
				if (loaded) {
					loaded.sync = SYNC_WAITING;
				}
				context.dispatch('journal/log', {
					uid: picture.uid, name: picture.name, index: picture.index,
					pictureid: picture.id, level: 'warn',
					message: 'envoi sans reponse, photo remise en attente',
				}, {root: true});
			}
		},
		
		// recalcule, pour une mission, les photos qui n'ont pas de confirmation
		// d'envoi et les remet en attente. Appelee a chaque synchronisation, y
		// compris sur une mission dont le formulaire est deja parti : une photo
		// non confirmee doit repartir sans action de l'utilisateur.
		async checkDeclared(context, {uid, ids, sent, lost}) {
			let all = await idb.getAllPictures();
			let stored = all.filter((p) => p.uid === uid);
			let known = stored.map((p) => p.id);
			let confirmed = sent || [];
			let alreadylost = lost || [];
			let now = Date.now();
			let pending = 0;
			
			// une photo declaree dans le formulaire dont l'enregistrement local a
			// disparu est definitivement perdue : la tracer, elle ne partira pas.
			// Une photo confirmee par eKo puis purgee localement n'est pas perdue :
			// c'est le cas normal apres removeSynced ou une eviction d'IndexedDB.
			let missing = (ids || []).filter((id) => {
				return known.indexOf(id) === -1 && confirmed.indexOf(id) === -1;
			});
			// l'alerte ne vaut qu'une fois : la situation est irreversible, la
			// rejouer a chaque synchronisation noie le journal
			let newmissing = missing.filter((id) => alreadylost.indexOf(id) === -1);
			if (newmissing.length) {
				context.dispatch('journal/log', {
					uid: uid, level: 'error', pictureid: newmissing.join(','),
					message: 'photos declarees dans le formulaire et introuvables en base locale',
				}, {root: true});
			}
			
			for (const picture of stored) {
				if (picture.sync === SYNC_FINISH) {
					continue;
				}
				pending++;
				if (picture.sync === SYNC_RUNNING
					&& picture.syncstartedat && (now - picture.syncstartedat) < SYNC_STALE_MS) {
					continue;
				}
				if (picture.sync !== SYNC_WAITING) {
					await idb.patchPicture(picture.id, {sync: SYNC_WAITING, syncstartedat: null});
				}
			}
			
			return {pending: pending, missing: missing, newmissing: newmissing};
		},
		
		async removeSynced(context, evtids){
			console.log('removeSynced');
			let pictures = await idb.getAllPictures();
			if (pictures.length){
				pictures.forEach((pic) => {
					if (pic.sync == SYNC_FINISH && evtids.indexOf(pic.uid) === -1) {
						idb.deletePicture(pic);
					}
				})
			}
		},
		
		async save(context, picture) {
			picture.uid = context.state.uid;
			picture.sync = SYNC_WAITING;
			// l'index compose le nom du fichier cote eKo (responseid-name-index) :
			// il doit identifier la photo, pas sa position dans la file. Il derivait
			// de state.pictures.length, qui repart a zero des que la file est
			// rechargee (redemarrage, purge, changement de mission) : deux photos
			// distinctes ressortaient alors sous le meme index et eKo les empilait
			// sous un libelle identique, bloquant l'envoi du rapport.
			// La cle IndexedDB est auto-incrementee et ne se rejoue jamais.
			picture.id = await idb.savePicture(picture);
			picture.index = picture.id;
			await idb.updatePicture(picture);
			context.commit('addpicture', picture);
		},
		
		async sync(context) {
			
			await context.dispatch('requeueStale');
			
			let tosyncs = await idb.getPicturesBySync(SYNC_WAITING);
			console.log('tosyncs', tosyncs);
			// sequentiel et attendu : un forEach non attendu rendait sync() resolue
			// avant le moindre envoi, et saturait le lien en lancant toutes les
			// photos de front sur reseau degrade
			for (const picture of tosyncs) {
				// chaque envoi est isole : l'echec d'une photo ne doit ni
				// interrompre la file ni faire sauter la suivante
				await context.dispatch('upload', picture);
			}
			
		},
		
		async upload(context, picture) {
			
			const trace = {
				uid: picture.uid, index: picture.index,
				name: picture.name, pictureid: picture.id,
			};
			
			try {
				
				picture.sync = SYNC_RUNNING;
				picture.syncstartedat = Date.now();
				await idb.updatePicture(picture);
				
				let file = base64ToBlob(picture.base64);
				
				const data = new FormData();
					data.append('mission-picture[]', file, getFilename(picture.base64));
					data.append('responseid', picture.responseid);
				
				let call = await api.postFile({
					url: 'intervention/v3/missions/' + picture.uid + '/pictures/save/' + picture.index + '/' + picture.name,
					params: data
				});
				
				let status = call ? call.status : null;
				
				// seul un 201 effectivement recu atteste l'ecriture du fichier :
				// tout autre code (200 d'un portail captif, reponse tronquee) laisse
				// la photo en attente plutot que de la perdre silencieusement
				if (status !== HTTP_CREATED) {
					picture.sync = SYNC_WAITING;
					picture.syncstartedat = null;
					await idb.updatePicture(picture);
					context.dispatch('journal/log', {
						...trace, level: 'error', status: status,
						message: 'reponse inattendue, photo laissee en attente',
					}, {root: true});
					return false;
				}
				
				picture.sync = SYNC_FINISH;
				await idb.updatePicture(picture);
				// la confirmation est memorisee cote intervention : elle doit
				// survivre a la suppression locale de la photo
				context.dispatch('interventions/markPictureSent', {
					uid: picture.uid, id: picture.id,
				}, {root: true});
				context.dispatch('journal/log', {...trace, level: 'ok', status: status}, {root: true});
				
				return true;
				
			} catch (e) {
				// timeout, erreur reseau, 400 "Aucun fichier recu", 500 "Envoi
				// incomplet" : dans tous les cas la photo reste a renvoyer
				console.log('Error sync picture', e, picture);
				picture.sync = SYNC_WAITING;
				picture.syncstartedat = null;
				await idb.updatePicture(picture);
				context.dispatch('journal/log', {
					...trace, level: 'error',
					status: errorStatus(e), message: errorMessage(e),
				}, {root: true});
				
				return false;
			}
			
		}
		
		
	},
	getters: {
		getByName: (state) => (responseid, name) => {
			// console.log('getByName',responseid, name);
			
			return state.pictures.filter((pic) => {
				return pic.responseid == responseid && pic.name == name;
			});
		},
		getAll: (state) => () => {
			// console.log('getAll', state.pictures);
			return state.pictures;
		}
		
		
	},
	
}

export default store